/**
 * Mobile Menu
 */
$headerheight = 0;
$header = $('#js-header');
$article = $('#js-article');
$hamburgerMenu = $('.js-hamburger-menu');
$mobileMenuClass = '.js-mobile-floating-menu';
$articlemargin = 0;

$hamburgerMenu.on('click', function() {
    if (!$floatingMobileMenu.hasClass('open')) {
        $floatingMobileMenu.height($(window).innerHeight() - $articlemargin);
    }

    $hamburgerMenu.toggleClass('is-active hamburger--collapse');
    $floatingMobileMenu.toggleClass('hidden');
    $floatingMobileMenu.toggleClass('open');
});

/**
 * Handling to dropdowns when on mobile menu
 * @type {string}
 */
$childrenMenuClass = '.children-menu';
$mobileDropdownIndicator = $($mobileMenuClass);

$('body').on('click', $mobileMenuClass + ' .js-dropdown-indicator:not(.dropdown-indicator--open)', function() {

    $('.js-dropdown-indicator').removeClass('dropdown-indicator--open');

    $(this).addClass('dropdown-indicator--open');
    $($mobileMenuClass + ' ' + $childrenMenuClass).slideUp();
    $(this).next($childrenMenuClass).slideDown();
});

$('body').on('click', $mobileMenuClass + ' .dropdown-indicator--open', function() {
    $(this).removeClass('dropdown-indicator--open');
    $(this).next($childrenMenuClass).slideUp();
});

/**
 *
 * @param breakpoint
 */
function mobileMenuDisplay(breakpoint) {
    $headerheight = $header.height();
    if ($headerheight != $articlemargin) {
        $article.css('margin-top', $headerheight);
        $articlemargin = $headerheight;
    }

    if ($(window).width() <= breakpoint) {
        if ($($mobileMenuClass).length === 0) {
            $floatingMobileMenu = $("<div class='mobile-floating-menu js-mobile-floating-menu hidden'></div>").append($('.js-main-navigation').clone());
            $floatingMobileMenu.appendTo($header);

            $(document).mouseup(function(e) {
                if (!$floatingMobileMenu.is(e.target) // if the target of the click isn't the container...
                    &&
                    $floatingMobileMenu.has(e.target).length === 0 // ... nor a descendant of the container
                    &&
                    $hamburgerMenu.hasClass('is-active')) {

                    if (!$hamburgerMenu.is(e.target) // if the target of the click isn't the button...
                        &&
                        $hamburgerMenu.has(e.target).length === 0 // ... nor a descendant of the button
                    ) {
                        $hamburgerMenu.click();
                    }
                }
            });
        }

    } else {
        $($mobileMenuClass).remove();
        $hamburgerMenu.removeClass('is-active hamburger--collapse');
    }
}

mobileMenuDisplay(768);

$(window).resize(function() {
    mobileMenuDisplay(768);
});
